import { inject, RESPONSE_INIT } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, RedirectCommand, Router, RouterStateSnapshot } from '@angular/router';
import { DskHomeUserStore } from '../../store/dskhome-user';
import { applyServer302Redirect } from '../../utils/server-redirects';

/**
 * This guard doesn't allow users that don't have UserRole.BACKOFFICE
 * to access protected routes
 */
export const dskhomeIsBackofficerGuard: CanActivateFn = (
  _route: ActivatedRouteSnapshot,
  _state: RouterStateSnapshot
) => {
  const router = inject(Router);
  const dskHomeUserStore = inject(DskHomeUserStore);
  const responseInit = inject(RESPONSE_INIT);

  if (!dskHomeUserStore.isBackOfficer()) {
    const homePagePath = router.parseUrl('/home');
    const serializedUrl = router.serializeUrl(homePagePath);

    applyServer302Redirect(responseInit, serializedUrl);

    return new RedirectCommand(homePagePath);
  }

  return true;
};
